import * as React from "react";
const SvgFiRrTankWater = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tank-water_svg__a)">
      <path
        fill="#062147"
        d="M19 0h-2a1 1 0 1 0 0 2h2c1.654 0 3 1.346 3 3v7.727A2 2 0 0 1 21 13c-.889 0-1.793-.586-2.058-1.333a1 1 0 0 0-1.884 0C16.793 12.414 15.889 13 15 13s-1.793-.586-2.057-1.333a1 1 0 0 0-1.886 0C10.793 12.414 9.89 13 9 13s-1.793-.586-2.057-1.333a1 1 0 0 0-1.886 0C4.793 12.414 3.89 13 3 13c-.355 0-.698-.097-1-.273V5c0-1.654 1.346-3 3-3h2a1 1 0 1 0 0-2H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m0 22H5c-1.654 0-3-1.346-3-3v-4.143c.325.084.658.143 1 .143a4.38 4.38 0 0 0 3-1.225A4.38 4.38 0 0 0 9 15a4.38 4.38 0 0 0 3-1.225A4.38 4.38 0 0 0 15 15a4.37 4.37 0 0 0 3-1.226A4.37 4.37 0 0 0 21 15c.342 0 .675-.059 1-.143V19c0 1.654-1.346 3-3 3M12 9c.935 0 1.813-.364 2.475-1.025 1.364-1.364 1.364-3.585.039-4.908l-1.338-1.499c-.597-.672-1.755-.671-2.352 0l-1.3 1.459a3.504 3.504 0 0 0 0 4.949 3.48 3.48 0 0 0 2.475 1.025z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tank-water_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTankWater;
